import { FloatingDialog } from "../atoms/FloatingDialog";
import { iconAhogo } from "../../../src/helpers/ImagesCache";
import useTranslation from "../../hooks/useTranslation";
import SimpleButton from "../NSButton/Types/SimpleButton";

const DialogOVANCEUnderConstruction = ({ onClose, visible }) => {
  const T = useTranslation();
  return (
    <FloatingDialog isOpen={visible} onClose={onClose}>
      <div className="flex flex-col w-full h-full items-center justify-center gap-5">
        <img src={iconAhogo} />
        <span className="font-bold text-center text-base  text-[24px]">
          {T("ovanceNotAvaliable")}
        </span>
        <div className="flex flex-wrap justify-center gap-4 w-full max-w-[450px]">
          <SimpleButton
            onClick={onClose}
            text={T("close")}
            variant="gray"
          />
        </div>
      </div>
    </FloatingDialog>
  );
};

export default DialogOVANCEUnderConstruction;
